if (!customElements.get('product-form')) {
	customElements.define(
		'product-form',
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector('form');
				if (!this.form) return;
				
				if (this.variantIdInput) {
					this.variantIdInput.disabled = false;
				}
				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
				this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
				this.submitButton = this.querySelector('[type="submit"]');
				
				if (this.submitButton) {
					this.submitButtonText = this.submitButton.querySelector('span');
					if (document.querySelector('cart-drawer')) {
						this.submitButton.setAttribute('aria-haspopup', 'dialog');
					}
				}

				this.hideErrors = this.dataset.hideErrors === 'true';
			}

			onSubmitHandler(evt) {
				if (evt) {
					evt.preventDefault();
				}
				
				if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

				this.handleErrorMessage();

				this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.classList.add('loading');
				this.querySelector('.loading__spinner').classList.remove('hidden');

				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				const formData = new FormData(this.form);
				
				if (this.cart) {
					formData.append(
						'sections',
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append('sections_url', window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {

					this.cart =
						document.querySelector('cart-notification') || document.querySelector('cart-drawer');

						console.log('pf form response', response, this.cart);
					
					// Check if there's an error
					const hasError = response.status;
					// Check if items were actually added (cart data exists)
					// Can be: full cart object (items/item_count), single line item (id/quantity), or sections response
					const hasCartData = response.items || 
						response.item_count !== undefined || 
						response.sections !== undefined ||
						(response.id && response.quantity !== undefined);
					
					if (hasError) {
						publish(PUB_SUB_EVENTS.cartError, {
							source: 'product-form',
							productVariantId: formData.get('id'),
							errors: response.errors || response.description,
							message: response.message,
						});
						this.handleErrorMessage(response.description);

						const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
						if (soldOutMessage) {
							this.submitButton.setAttribute('aria-disabled', true);
							if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
							soldOutMessage.classList.remove('hidden');
						}
						this.error = true;
						
						// Check if error message indicates partial success (items were still added)
						const errorMessage = response.description || response.message || '';
						const isPartialSuccess = errorMessage.toLowerCase().includes('were added') || 
							errorMessage.toLowerCase().includes('items were added') ||
							errorMessage.toLowerCase().includes('only') && errorMessage.toLowerCase().includes('added');
						
						// If there's an error but items were still added, we still need to update the cart
						if (!hasCartData && !isPartialSuccess) {
							return;
						}
						
						// If partial success but no cart data in response, we need to fetch it
						if (isPartialSuccess && !hasCartData) {
							console.log('pf form partial success but no cart data, fetching fresh cart data');
							// Fetch cart sections to update the UI
							Promise.all([
								fetch(`${routes.cart_url}?section_id=cart-drawer`).then(r => r.text()),
								fetch(`${routes.cart_url}?section_id=cart-icon-bubble`).then(r => r.text()),
								fetch(`${routes.cart_url}?section_id=cart-json`).then(r => r.text())
							]).then(([drawerHtml, bubbleHtml, jsonHtml]) => {
								// Update cart drawer
								const drawerParser = new DOMParser().parseFromString(drawerHtml, 'text/html');
								const targetContent = document.querySelector('#CartDrawer-Content');
								const sourceContent = drawerParser.querySelector('#CartDrawer-Content');
								if (targetContent && sourceContent) {
									targetContent.replaceWith(sourceContent);
								}
								
								// Update the cart drawer's is-empty class based on cart state
								const cartDrawer = document.querySelector('cart-drawer');
								const cartDrawerItems = document.querySelector('cart-drawer-items');
								if (cartDrawer && cartDrawerItems) {
									if (cartDrawerItems.classList.contains('is-empty')) {
										cartDrawer.classList.add('is-empty');
									} else {
										cartDrawer.classList.remove('is-empty');
									}
								}
								
								// Update cart icon bubble
								const bubbleParser = new DOMParser().parseFromString(bubbleHtml, 'text/html');
								const targetBubble = document.querySelector('#cart-icon-bubble');
								const sourceBubble = bubbleParser.querySelector('#cart-icon-bubble');
								if (targetBubble) {
									if (sourceBubble) {
										targetBubble.innerHTML = sourceBubble.innerHTML;
									} else if (bubbleHtml) {
										targetBubble.innerHTML = bubbleHtml;
									}
								}
								
								// Update cart JSON
								const jsonParser = new DOMParser().parseFromString(jsonHtml, 'text/html');
								const targetJson = document.querySelector('#shopify-section-cart-json');
								const sourceJson = jsonParser.querySelector('#shopify-section-cart-json');
								if (targetJson) {
									if (sourceJson) {
										targetJson.innerHTML = sourceJson.innerHTML;
									} else if (jsonHtml) {
										targetJson.innerHTML = jsonHtml;
									}
								}
								
								// Re-setup elements after content replacement with a small delay
								// to ensure DOM is fully updated
								setTimeout(() => {
									if (cartDrawer) {
										cartDrawer.setupElements();
										
										// Manual fallback: ensure all close buttons have event listeners
										const allCloseButtons = document.querySelectorAll('[data-close="cart-drawer"]');
										allCloseButtons.forEach(button => {
											// Remove any existing listeners to avoid duplicates
											button.removeEventListener('click', cartDrawer.close.bind(cartDrawer));
											// Add the listener
											button.addEventListener('click', cartDrawer.close.bind(cartDrawer));
										});
									}
								}, 10);
							}).catch((e) => {
								console.error('Error fetching cart data:', e);
							});
							return;
						}
					} else if (!this.cart && !hasCartData) {
						console.log('skip cart redirect');
						//window.location = window.routes.cart_url;
						return;
					}

					console.log('pf form hasCartData', hasCartData, this.cart);

					// Update cart if we have cart data (either success or partial success with error)
					// Always update if we have cart data, even if this.cart isn't set (cart drawer exists on page)
					if (hasCartData) {
						let shouldFetchAddons = false;
						const productInfoWrapper = this.closest('product-info');
						const currentVariant = productInfoWrapper ? productInfoWrapper.querySelector('[data-selected-variant]') : null;

						console.log('looking for currentVariant', currentVariant);
						
						if (currentVariant) {
							const currentVariantData = JSON.parse(currentVariant.innerHTML);
							if (currentVariantData.has_addons) {
								shouldFetchAddons = true;
							}
						}

						// Don't open drawer if there's an error, but still update the cart data
						publish(PUB_SUB_EVENTS.cartUpdate, {
							source: 'product-form',
							productVariantId: formData.get('id'),
							productUrl: this.dataset.productUrl,
							cartData: response,
							openDrawer: !hasError, // Only open drawer if no error
							fetchAddons: shouldFetchAddons,
						}).then(() => {
							//CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
						});

						if (!hasError) {
							this.error = false;
						}
						const quickAddModal = this.closest('quick-add-modal');
						if (quickAddModal) {
							console.log('got quickAddModal', quickAddModal);
							quickAddModal.afterAddToCart();
						}
					}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						if (this.submitButton) {
							this.submitButton.classList.remove('loading');
							// Re-enable button unless it's actually sold out
							const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
							if (!soldOutMessage || soldOutMessage.classList.contains('hidden')) {
								this.submitButton.removeAttribute('aria-disabled');
							}
						}
						if (this.cart && this.cart.classList.contains('is-empty'))
							this.cart.classList.remove('is-empty');
						const loadingSpinner = this.querySelector('.loading__spinner');
						if (loadingSpinner) loadingSpinner.classList.add('hidden');

						//CartPerformance.measureFromEvent('add:user-action', evt);
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
				if (!this.errorMessageWrapper) {
					// Try searching in parent elements (in case the form structure is different)
					this.errorMessageWrapper = this.closest('product-info')?.querySelector('.product-form__error-message-wrapper') ||
						document.querySelector('.product-form__error-message-wrapper');
					if (!this.errorMessageWrapper) return;
				}
				this.errorMessage =
					this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

				if (errorMessage) {
					this.errorMessageWrapper.removeAttribute('hidden');
					this.errorMessage.textContent = errorMessage;
				} else {
					this.errorMessageWrapper.setAttribute('hidden', '');
				}
			}

			toggleSubmitButton(disable = true, text) {
				// Re-query button references in case they were updated via innerHTML
				this.submitButton = this.querySelector('[type="submit"]');
				if (!this.submitButton) {
					console.warn('ProductForm: Submit button not found');
					return;
				}
				
				this.submitButtonText = this.submitButton.querySelector('span');
				if (!this.submitButtonText) {
					console.warn('ProductForm: Submit button text span not found');
					return;
				}
				
				if (disable) {
					this.submitButton.setAttribute('disabled', 'disabled');
					if (text) this.submitButtonText.textContent = text;
				} else {
					this.submitButton.removeAttribute('disabled');
					// Use custom text if provided, otherwise use default addToCart text
					this.submitButtonText.textContent = text || window.variantStrings.addToCart;
				}
			}

			get variantIdInput() {
				if (!this.form) return null;
				return this.form.querySelector('[name=id]');
			}
		}
	);
}
